module.exports = __webpack_public_path__ + "img/swingLines2.38fc5e17.png";